<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span v-if="id > 0" class="pr-2 mr-2 font-bold text-2xl"
        >Retur Pembelian - Edit</span
      >
      <span v-else class="pr-2 mr-2 font-bold text-2xl"
        >Retur Pembelian - Tambah</span
      >
      <div>
        <i class="pi pi-home mr-2"></i>
        <span v-if="id > 0" class="font-small"
          >/ Kembali / Retur Pembelian / Edit</span
        >
        <span v-else class="font-small"
          >/ Kembali / Retur Pembelian / Tambah</span
        >
      </div>
    </div>
    <form-faktur-kembali :id="id" />
  </div>
</template>

<script>
import FormFakturKembali from '@/components/pembelian/FormFakturKembali'

export default {
  components: {
    FormFakturKembali,
  },
  data() {
    return {
      id: parseInt(this.$route.params.id),
    }
  },
}
</script>
